(function () {

  function expandCard(card) {
    var body = card.querySelector('.own5-card-body');
    if (!body) return;
    card.classList.add('own5-expanded');
    body.style.maxHeight = body.scrollHeight + 200 + 'px';
    body.style.opacity = '1';
  }

  function collapseCard(card) {
    var body = card.querySelector('.own5-card-body');
    if (!body) return;
    card.classList.remove('own5-expanded');
    body.style.maxHeight = '0';
    body.style.opacity = '0';
  }

  function setupAccordion() {
    var cards = document.querySelectorAll('.own5-plan-card');
    if (!cards.length) return false;
    if (document.querySelector('.own5-card-body')) return true;

    cards.forEach(function (card) {
      var badge    = card.querySelector('.own5-best-badge');
      var header   = card.querySelector('.own5-plan-header');
      var priceRow = card.querySelector('.own5-price-row');
      var billing  = card.querySelector('.own5-billing-note');
      if (!header) return;

      // Everything except badge, header, price row, billing note goes into the collapsible body
      var body = document.createElement('div');
      body.className = 'own5-card-body';
      body.style.maxHeight = '0';
      body.style.opacity = '0';
      body.style.overflow = 'hidden';
      body.style.transition = 'max-height 0.35s ease, opacity 0.25s ease';

      var toMove = [];
      Array.from(card.children).forEach(function (child) {
        if (
          child !== badge &&
          child !== header &&
          child !== priceRow &&
          child !== billing
        ) {
          toMove.push(child);
        }
      });
      toMove.forEach(function (child) { body.appendChild(child); });

      card.appendChild(body);

      // Click: expand this, collapse others
      card.addEventListener('click', function () {
        cards.forEach(function (c) {
          if (c === card) expandCard(c);
          else collapseCard(c);
        });
      });
    });

    // Expand selected card on load
    cards.forEach(function (card) {
      if (card.classList.contains('own5-selected')) expandCard(card);
    });

    return true;
  }

  var attempts = 0;
  var poll = setInterval(function () {
    attempts++;
    var done = setupAccordion();
    if (done || attempts > 80) clearInterval(poll);
  }, 300);

})();